import { useEffect, useRef, useState } from "react";
import { message } from "antd";
import { useSelector } from "react-redux";

import { HandleMakeCall, MakeCallData } from "../@types/types";
import { usePostForVoipProviderMutation } from "../store/endpoints/voicesdk";
import { CALL_DIRECTION, PROVIDERS } from "../utils/constants";
import IncomingCallCentre from "../sdk/IncomingCallCentre";
import TelnyxSDK from "../sdk/TelnyxSDK";

type SdkProps = {
  provider: string;
  accessToken: string;
};

/**
 * sdk hook for call center
 * @param {string} profileId
 */
export const useSdk = ({ token }: { token: SdkProps[] }) => {
  const [accessTokenError, setAccessTokenError] = useState<any>(null);
  const [callInfo, setCallInfo] = useState({});
  const lastCalledNumber = useRef<string | null>(null);

  const [postForVoipProvider] = usePostForVoipProviderMutation();
  const makeCallData = useSelector(
    (state: MakeCallData) => state?.activeCollapse?.makeCallData
  );

  const handleMakeCall = async (data: HandleMakeCall) => {
    try {
      if (data?.myNumber?.myNumber) {
        const res = await postForVoipProvider({
          data: {
            fromNumber: data?.myNumber?.myNumber,
            toNumber: data.dialcode + data.number,
          },
        }).unwrap();
        setCallInfo({
          ...data,
          my_phone_number: data?.myNumber?.myNumber,
          // callID: res?.data?.data?.call_id,
          sdk: res?.data?.provider,
          callDirection: CALL_DIRECTION.OUTBOUND,
        });
      } else message.error("You do not own any phone number");
    } catch (error) {
      // showResponseMessage({
      //   msg: (error as ERROR)?.message,
      //   type: "ERROR",
      //   isDialer: true,
      // });
    }
  };

  const callPocket = (sdk: string) => {
    return {
      twilio: (
        <IncomingCallCentre
          callInfo={callInfo}
          setCallInfo={setCallInfo}
          accessToken={
            token?.find((item) => item.provider === PROVIDERS.TWILIO)
              ?.accessToken ?? ""
          }
          setAccessTokenError={setAccessTokenError}
        />
      ),
      telnyx: (
        <TelnyxSDK
          callInfo={callInfo}
          setCallInfo={setCallInfo}
          loginCredential={
            token?.find((item) => item.provider === PROVIDERS.TELNYX) ?? {
              username: "",
              password: "",
            }
          }
        />
      ),
    }[sdk];
  };
  // useEffect(() => {
  //   if (makeCallData?.number) {
  //     handleMakeCall({
  //       name: makeCallData?.name,
  //       number: makeCallData?.number,
  //       dialcode: makeCallData?.dialingcode,
  //       callDirection: CALL_DIRECTION.OUTBOUND,
  //       myNumber: makeCallData?.myNumber,
  //     });
  //   }
  // }, [makeCallData]);
  useEffect(() => {
    if (
      makeCallData?.number &&
      makeCallData?.number !== lastCalledNumber.current
    ) {
      handleMakeCall({
        name: makeCallData?.name,
        number: makeCallData?.number,
        dialcode: makeCallData?.dialingcode,
        callDirection: CALL_DIRECTION.OUTBOUND,
        myNumber: makeCallData?.myNumber,
      });
      lastCalledNumber.current = makeCallData.number;
    }
  }, [makeCallData]);

  return {
    accessTokenError,
    callPocket,
  };
};
